export default {
  nav: {
    home: 'Home',
    articles: 'Articles',
    tech: 'Tech',
    software: 'Software',
    tutorial: 'Tutorials',
    resource: 'Resources',
    news: 'News',
    tools: 'Tools',
    about: 'About',
    sponsor: 'Membership',
    copyright: 'Copyright'
  },
  header: {
    searchPlaceholder: 'Search articles...',
    searchMobilePlaceholder: 'Search articles & tools...',
    search: 'Search',
    navLabel: 'Navigation',
    drawerHint: 'Browse · tap to navigate',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    langZh: '中文',
    langEn: 'EN'
  },
  footer: {
    nav: 'Navigate',
    about: 'About',
    copyright: 'Copyright',
    feedback: 'Feedback',
    followUs: 'Follow us',
    channelsHint: 'Hover or tap QR to enlarge'
  },
  home: {
    readMore: 'Read more',
    noCarousel: 'No featured slides yet',
    noCarouselHint: 'Enable “Show on homepage carousel” in the admin article editor',
    latest: 'Latest',
    featured: 'Featured',
    views: 'views',
    softwareTitle: 'Software picks',
    softwareSubtitle: 'Handy apps for work, study, and development',
    tutorialTitle: 'Tutorials',
    tutorialSubtitle: 'From basics to real-world projects',
    resourceTitle: 'Resources',
    resourceSubtitle: 'Learning paths, open source, and book lists',
    techTitle: 'Tech articles',
    techSubtitle: 'Frontend, engineering, and performance',
    all: 'All'
  },
  articles: {
    count: '{n} articles',
    searchPrefix: 'Search: {q}',
    all: 'All',
    tech: 'Tech',
    software: 'Software',
    tutorial: 'Tutorials',
    resource: 'Resources',
    news: 'News',
    titleAll: 'All articles',
    titleTech: 'Tech articles',
    titleSoftware: 'Software picks',
    titleTutorial: 'Tutorials',
    titleResource: 'Resources',
    titleNews: 'News',
    subCategory: 'Subcategory',
    softwareCats: 'Software categories',
    tutorialCats: 'Tutorial categories',
    resourceCats: 'Resource categories',
    techCats: 'Tech categories',
    tags: 'Tags',
    empty: 'No matching articles',
    featured: 'Featured'
  },
  article: {
    home: 'Home',
    body: 'Article',
    back: 'Back',
    repostFrom: 'Reposted from: ',
    readMinutes: '~{n} min',
    views: 'views',
    copyLink: 'Copy link',
    loadingBody: 'Loading content…',
    thanks: 'Thanks for reading',
    moreType: 'More {type}',
    related: 'Related',
    loading: 'Loading article…',
    notFound: 'Article not found',
    backToList: 'Back to articles',
    translationFallback: 'No English translation yet — showing Chinese original'
  },
  tools: {
    badge: 'Online toolkit',
    heroTitle: 'Practical tools, ready to use',
    heroDesc: 'PDF, images, barcodes, webmaster, life, networking, and config conversion — processed locally in your browser, fast and private.',
    countTools: 'tools',
    countCats: 'categories',
    localPct: 'local',
    searchPlaceholder: 'Search tools, e.g. PDF merge, QR code…',
    frequent: 'Frequent tools',
    frequentHintLogin: 'Synced to your account by usage; pin to keep on top',
    frequentHintGuest: 'Stored on this device; sign in to sync across devices',
    clear: 'Clear',
    clearConfirm: 'Clear frequent tools history?',
    cleared: 'Cleared',
    pin: 'Pin',
    unpin: 'Unpin',
    removeFrequent: 'Remove',
    frequentEmpty: 'Tools you use will appear here for quick access',
    all: 'All',
    toolsInCat: '{n} tools',
    empty: 'No matching tools',
    notFound: 'Tool not found',
    backHub: 'Back to toolkit',
    allTools: 'All tools',
    loginRequired: 'Sign in to use',
    loginTip: 'This tool requires an account. After signing in, files are processed locally in your browser.',
    loginNow: 'Sign in',
    tip: 'Notice'
  },
  about: {
    browseArticles: 'Browse articles',
    contactMe: 'Contact',
    role: 'Frontend developer · technical writer',
    bio1: 'A frontend developer focused on web engineering and UX. This blog is where I share notes, ideas, software picks, and project experience.',
    bio2: 'I aim to explain complex topics clearly and share useful tools so every visit is worthwhile.',
    online: 'Creating online',
    focusEyebrow: 'FOCUS',
    focusTitle: 'What I work on',
    focusSub: 'Write to capture experience; share to connect with more developers',
    focusWrite: 'Technical writing',
    focusWriteDesc: 'Frontend practice, engineering, and performance — explained clearly.',
    focusTools: 'Tool recommendations',
    focusToolsDesc: 'Curated apps and utilities that speed up daily work and learning.',
    focusTutorial: 'Hands-on tutorials',
    focusTutorialDesc: 'Project-based guides from beginner to advanced.',
    contentEyebrow: 'CONTENT',
    contentTitle: 'What you will find',
    contentSub: 'Four pillars covering beginner to advanced learning paths',
    techDesc: 'Frontend, performance, and engineering practice',
    softwareDesc: 'Utilities, office, and developer productivity apps',
    tutorialDesc: 'Structured learning from basics to advanced',
    resourceDesc: 'Learning materials, open source, and books',
    statArticles: 'Articles',
    statTech: 'Tech',
    statSoftware: 'Software',
    statTutorialResource: 'Tutorials & resources',
    techGroupFront: 'Frameworks',
    techGroupLang: 'Languages & styles',
    techGroupEng: 'Engineering',
    techGroupOther: 'Other'
  },
  sponsor: {
    badge: 'Membership',
    title: 'Support {name} and unlock more content',
    desc: 'Your support helps keep tutorials, software picks, and tech articles coming. Choose how to start or renew.',
    memberUntil: 'Membership active until',
    renewNote: 'Renewals extend from the current expiry date',
    plansRenew: 'Renewal plans',
    plansBuy: 'Membership plans',
    plansDirectTip: 'Pick a plan and pay — membership activates automatically after payment',
    plansExternalTip: 'Buy on the card platform, then return here to redeem a CDK',
    plansIntroTip: 'Plan overview — activate with a redeem code after purchase',
    originalPrice: 'Was ¥{price}',
    unitPrice: 'About {unit}',
    renew: 'Renew',
    sponsorNow: 'Sponsor now',
    goBuy: 'Buy now',
    onlineBuy: 'Buy membership online',
    empty: 'Membership purchase is not available yet. Please contact the admin.',
    faqTitle: 'FAQ'
  },
  profile: {
    member: 'Member',
    normalUser: 'Regular user',
    joinedAt: 'Joined {date}',
    memberUntil: 'Member until {date}',
    changeAvatar: 'Change avatar',
    admin: 'Admin',
    renew: 'Renew',
    openSponsor: 'Become a member',
    history: 'History',
    orders: 'Orders',
    unlocked: 'Unlocked',
    sideLabel: 'Account',
    navAria: 'Profile navigation',
    tabInfo: 'Profile',
    tabInfoShort: 'Profile',
    tabSecurity: 'Security',
    tabSecurityShort: 'Security',
    tabHistory: 'History',
    tabHistoryShort: 'History',
    tabPoints: 'Points',
    tabPointsShort: 'Points',
    tabMember: 'Membership',
    tabMemberShort: 'Member',
    tabOrders: 'Orders',
    tabOrdersShort: 'Orders'
  },
  copyright: {
    backHome: 'Back to home',
    title: 'Copyright notice',
    desc: 'Welcome to “{name}”. Please read the terms below. By using this site you agree to this notice.',
    updated: 'Last updated: Mar 10, 2026',
    effective: 'Effective: Jan 1, 2026',
    toc: 'Contents',
    contactPrefix: 'Questions about this notice? Email',
    contactSuffix: 'and we will reply within a reasonable time.',
    enNotice: 'The English version is for reference only. If it conflicts with the Chinese text, the Chinese version prevails.'
  },
  redirect: {
    back: 'Go back',
    leaving: 'You are leaving this site',
    invalid: 'Invalid link',
    leavingDesc: 'You are about to open a third-party site. Please confirm the destination first.',
    invalidDesc: 'This link could not be parsed. Check that the address is correct.',
    targetSite: 'Destination',
    copy: 'Copy',
    copied: 'Copied',
    linkName: 'Link title',
    fromArticle: 'From article',
    safety: 'Safety tips',
    tip1: 'Third-party content, privacy, and security are the responsibility of that site.',
    tip2: 'Do not enter passwords or payment details on unfamiliar pages.',
    tip3: 'If a page looks suspicious, close it and return here.',
    cancel: 'Cancel',
    confirm: 'Continue',
    countdown: 'After you confirm, the link opens in a new tab; this page stays open',
    invalidReason: 'Possible causes: bad URL format, unsupported protocol, or missing redirect parameter.',
    backHome: 'Back to home',
    footerTip: '{name} shows this warning before external links to help keep browsing safer'
  },
  common: {
    langSwitched: 'Language updated',
    tip: 'Notice'
  }
}
